module.exports = __webpack_public_path__ + "static/media/Chimera.429c7e40.jpg";